import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;
	return {
		rowActions: [
			{
				name: 'Edit',
				id: 'edit',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.homePageLayout,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].editLayoutsOrder,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Show Layout Order',
				id: 'layouts',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.homePageLayout,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].showLayoutOrder,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Remove from App',
				id: 'remove',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.homePageLayout,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].removeLayouts,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			}
		],

		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.homePageLayout,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].createLayout,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		},
		submitAction: {
			name: 'Submit',
			id: 'submit',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.homePageLayout,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].submitLayouts,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		},
		clearAction: {
			name: 'Clear',
			id: 'clear',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.homePageLayout,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].clearLayouts,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};

export default {
	makeActionList
};
